import React from 'react';
import {DynamicForm} from '../dynamic-form';
import _ from 'lodash';
import {
  ModalFormWrapper,
  StyledModalFormWrapper,
  StyledSuccessView,
} from './styles';
import {SuccessView} from '../form-state-views/success-view';
import {FailedView} from '../form-state-views/failed-view';
import {UsedVehicle} from '../../../typing/used-inventory';
import {formStatus} from '../../../typing/forms';
import {FormTranslation} from '../../../typing/translations';
import {CustomImageProps} from '@vw-marketing/us-components';
import { AppConstants } from '../../../utils/app-constants';
import { DEFAULT_FIELDS_CONFIGURATION } from '../formik-custom/helpers';

interface FormProps {
  formState: formStatus;
  setFormState: (state: formStatus) => void;
  onCloseHandle?: () => void;
  fieldsConfiguration: any;
  vehicle?: UsedVehicle;
  translations: FormTranslation;
  faHostServerUrl?: string;
}
const Form: React.FC<FormProps> = (props) => {
  const {
    formState,
    setFormState,
    onCloseHandle,
    fieldsConfiguration,
    translations,
    vehicle,
    faHostServerUrl
  } = props;
  const {
    legalDisclaimer,
    submitLabel,
    failedMessage,
    successMessage,
    formName,
  } = translations;


  const onCloseHandleForm = () => {
    onCloseHandle && onCloseHandle();
  };

  const successImage: CustomImageProps = {
    src: vehicle?.mediaImageUrl || '',
    alt: `${vehicle?.modelYear}-${vehicle?.model}-${vehicle?.trimLevel}`,
    srcPlaceholder: faHostServerUrl+AppConstants.Ngw6Logo480x216,
    srcErrorImage: AppConstants.NoFoundImageError348x196,
  };

  return (
    <ModalFormWrapper withTopPadding={false}>
      <StyledModalFormWrapper>
        {formState === 'filling' || formState === 'submitting' ? (
          <DynamicForm
            requiredFields={fieldsConfiguration}
            submitLabel={submitLabel}
            legalDisclaimer={legalDisclaimer}
            fieldsConfig={DEFAULT_FIELDS_CONFIGURATION}
          >
            <></>
          </DynamicForm>
        ) : formState === 'success' ? (
          <StyledSuccessView>
            <SuccessView
              okHandler={onCloseHandleForm}
              inline={false}
              contentConfiguration={{...successMessage, image: successImage}}
              faHostServer={faHostServerUrl}
            />
          </StyledSuccessView>
        ) : (
          <FailedView
            formName={formName || '${formConfiguration.formName}'}
            setFormStateHandler={setFormState.bind(null, 'filling')}
            inline={false}
            contentConfig={failedMessage}
          />
        )}
      </StyledModalFormWrapper>
    </ModalFormWrapper>
  );
};

export default Form;
